import web from "../web";

class SitesService {
    index(token){
        return web.get("/api/sites", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/sites", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/sites/${id}`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/sites/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/sites/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new SitesService()